module.exports = __webpack_public_path__ + "img/wxkf.c4c9aeb6.jpg";